export default class BackgroundMusicCommandOptions {
  constructor(public fallThrough: boolean) {}
}
